const ROLE_ADMINISTRATOR = 'beststart.loggingreports.admin';

const ALL_ROLES = [
    ROLE_ADMINISTRATOR,
];

const ADMINS = [
    ROLE_ADMINISTRATOR,
];

const roles = {
    ROLE_ADMINISTRATOR,
    ALL_ROLES,
    ADMINS,
};

export default roles;
